import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manual-rostering',
  templateUrl: './manual-rostering.component.html',
  styleUrls: ['./manual-rostering.component.css']
})
export class ManualRosteringComponent implements OnInit {
 
  constructor() { }

  ngOnInit(): void {
  }

}
